import { useMemo } from 'react';
import useURLparams from 'helpers/hooks/useURLparams';
import { t } from 'i18next';
import { Typography } from '@mui/material';
import FullWidthContent from 'layouts/FullWidthContent';
import { useCustomerId, useShowAreaFeature } from '@hooks';
import { BoxContainer, MainMenuLayout } from '@layouts';
import { Table } from '@molecules';
import { SelectCustomer } from '@organisms';
import { buildColumnsForConsolidatedDispersionsList, DEFAULT_ROWS_PER_PAGE } from './constants';
import useConsolidatedDispersionsList from './data/useConsolidatedDispersionsList';
import SearchBox from './modules/SearchBox';

/**
 * ConsolidatedDispersionsList screen
 */
const ConsolidatedDispersionsList = () => {
  const { customerId } = useCustomerId();
  const { params } = useURLparams<{
    toDate?: string;
    fromDate?: string;
    customerId?: number;
    limit?: string;
    page?: string;
  }>();
  const { data, isLoading, handlePageChange, handleRowsPerPageChange } =
    useConsolidatedDispersionsList();

  const { showAreaFeature } = useShowAreaFeature();

  const columns = useMemo(() => {
    return buildColumnsForConsolidatedDispersionsList(showAreaFeature).filter(
      (item) => !item?.hide
    );
  }, [showAreaFeature]);

  return (
    <MainMenuLayout>
      <FullWidthContent>
        {!customerId ? (
          <BoxContainer>
            <Typography variant='h3'>{t('COMMON:COMPANY')}</Typography>
            <SelectCustomer />
          </BoxContainer>
        ) : (
          <>
            <SearchBox isLoading={isLoading} dataLength={data?.page?.length} />
            <Table
              count={data?.totalCount || 0}
              isLoading={isLoading}
              items={data?.page}
              columns={columns}
              page={params?.page || 1}
              rowsPerPage={params?.limit || DEFAULT_ROWS_PER_PAGE}
              onPageChange={handlePageChange as () => void}
              onRowsPerPageChange={handleRowsPerPageChange as () => void}
            />
          </>
        )}
      </FullWidthContent>
    </MainMenuLayout>
  );
};
export default ConsolidatedDispersionsList;
